import React from 'react';
import { BroadcastSectionProps } from '../types';

const BroadcastSection: React.FC<BroadcastSectionProps> = ({ 
  message, 
  onChange, 
  onSend, 
  disabled 
}) => {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !disabled) {
      onSend();
    }
  };

  return (
    <div className="broadcast-section">
      <h4>📢 Broadcast Message</h4>
      <input
        type="text"
        className="broadcast-input"
        placeholder="Enter message to broadcast..."
        value={message}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      <button 
        className="btn btn-broadcast" 
        onClick={onSend}
        disabled={disabled}
      >
        📡 Send Broadcast
      </button>
    </div>
  );
};

export default BroadcastSection;
